import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import topback from "../images/beetitle.png";
import { useEffect, useState } from 'react';
import AR1 from "../pdf/ODL.pdf"
import pdficon from "../images/pdf-icon.jpg";
function E_learning() {
  const Urlmain = "https://gcbeetan.co.in/admin/uploads/";
  const [user, setUser] = useState([]);
  const fetchData = () => {
    return fetch("https://gcbeetan.co.in/admin/api/api.php/notifications/e_learning")
      .then((response) => response.json())
      .then((data) => setUser(data));
  }
  useEffect(() => {
    fetchData();
  }, [])
  return (
    <>
      <Header />
      <section class="content-section title-top" style={{ backgroundImage: `url(${topback})` }}>
        <div class="pattern-overlay">
          <div class="container">
            <div class="row">
              <div class="col-lg-12 title-heading">
                <h2>E-learning</h2>
              </div>
            </div>
          </div>
        </div>
      </section>


      <div class="container">

        <div class="show-list mt-5 pb-5">
          <ul>
            {user && user.length > 0 && user.map((userObj, index) => (
              <li><i class="fa fa-check-circle"></i><a href={Urlmain + userObj.myfile} className="list-inner" target="_blank">{userObj.title}</a></li>
            ))}
          </ul>
        </div>

        <div class="row">
          <div class="col-2 d-inline float-none align-self-center"><img class="border rounded pdficon" src={pdficon} style={{ width: '128px;' }} /></div>
          <div class="col-6">
            <p className="pdfpara"><a href={AR1} target="_blank"><strong> List of UGC Recognised ODL/Online </strong></a></p>
          </div>
          <div class="col-2 text-center justify-content-center align-self-center">
            <div class="progress d-flex align-items-lg-center">
            </div>
          </div>
          <div class="col-2 align-self-center"><a href={AR1} target="_blank" class="btn btn-back" style={{ width: '150px;', height: '36px;' }}>Download  <i class="icon ion-ios-arrow-thin-down"></i></a></div>
        </div>
        <div className="container mt-5 pb-5">
        <div className="schloarship-main">
          <p className="pdfpara" style={{ textAlign: "center" }}><a href="https://ndl.iitkgp.ac.in/"><strong>"https://ndl.iitkgp.ac.in/"</strong></a></p>
        </div>
      </div>
      </div>
      <Footer />
    </>
  );
}

export default E_learning;